import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { Toast } from '../models/toast';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private id = 1;
  public toastSubject = new Subject<Toast>();

  constructor() {}

  public get toasts$(): Observable<Toast> {
    return this.toastSubject.asObservable();
  }

  public show(toast: Partial<Toast>) {
    toast = {
      timeout: 5000,
      type: 'info',
      ...toast,
      id: this.id,
    };
    this.toastSubject.next(toast as Toast);
    this.id += 1;
  }
}
